/** eslint-disable */

import api from '@edu-fe/api'

export default {
  name: 'group',
  getGroupData: api.create('/group/info'),
  getGroupQrcode: api.create('/weixin/group/qrcode'),
  isSubsribe: api.create('/weixin/is/subscribe')
}
